var React = require('react');

function ProjectAwardsInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.00781 12.9525L13.6428 15.75L12.4128 10.4775L16.5078 6.93L11.1153 6.4725L9.00781 1.5L6.90031 6.4725L1.50781 6.93L5.60281 10.4775L4.37281 15.75L9.00781 12.9525Z","fill":"#FF00FF"}));
}

ProjectAwardsInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = ProjectAwardsInline;

ProjectAwardsInline.default = ProjectAwardsInline;
